import { Component } from '@angular/core';

@Component({
  selector: 'my-estadoResultados',
  styles: [],
  templateUrl: 'estadoResultados.component.html'
})

export class EstadoResultadosComponent {}


// WEBPACK FOOTER //
// ./src/app/Contabilidad/estadoResultados/estadoResultados.component.ts